import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=2e877b86&"
import script from "./Preloader.vue?vue&type=script&lang=js&"
export * from "./Preloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports